import { useRolesStore } from '@/store/roles';

export const usersOptions = {
    getRoles: async (query: string | Record<string, any> = '') => {
        const store = useRolesStore();
        await store.fetchRoles(query);
        return store.roles;
    },
}